import PropTypes from 'prop-types';
import React from 'react';
import orderBy from 'lodash/orderBy';
import { findIndex } from 'lodash/array';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { getTariffsUsage } from 'utils/TariffAPIUtils';
import CustomersStore from 'stores/CustomerDetailsStore';
import paginate from 'utils/pagination-util';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import { Glyphicon, Grid, Row, Col, Pagination } from 'react-bootstrap';
import CustomerSearch from 'components/site/customer-search';
import TariffConfirmationButton from './TariffConfirmationButton';
import ToastStore from 'stores/ToastStore';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
function getStateFromStore() {
    const shipper = CustomersStore.getShipper();
    if (shipper) {
        shipper.tariffs = shipper.tariffs.filter((tariff) => tariff != null);
    }
    return {
        shippers: CustomersStore.getShippers(),
        shipper: CustomersStore.getShipper(),
    };
}
class TariffShippersTable extends React.Component {
    constructor(props) {
        super(props);
        this.onPerPage = (e) => {
            let value = e.target.value;
            this.setState((prevState) => {
                if (value) {
                    return {
                        pagination: Object.assign(Object.assign({}, (prevState.pagination || {})), { perPage: parseInt(value, 10) }),
                    };
                }
            });
        };
        this.state = this.getInitialState();
        this.onChange = () => this.handleStoreChange();
    }
    showTariffWarning(title, body) {
        ToastStore.getNotifications().push({
            title,
            body,
            level: 'error',
        });
        ToastStore.emitChange();
    }
    getInitialState() {
        const { t } = this.props;
        const getSortingColumns = () => this.state.sortingColumns || {};
        const sortable = sort.sort({
            getSortingColumns,
            onSort: (selectedColumn) => {
                this.setState((prevState) => {
                    const { sortingColumns } = prevState;
                    return {
                        sortingColumns: sort.byColumns({
                            sortingColumns,
                            selectedColumn,
                        }),
                    };
                });
            },
        });
        return {
            sortingColumn: null,
            columns: [
                {
                    property: 'company_name',
                    header: {
                        label: t('COMPANY_NAME'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                },
                {
                    property: 'email',
                    header: {
                        label: t('EMAIL'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                },
                {
                    property: 'phone',
                    header: {
                        label: t('PHONE'),
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                },
                {
                    cell: {
                        formatters: [
                            (value, { rowData }) => {
                                const idx = findIndex(this.state.shippers, {
                                    _id: rowData._id,
                                });
                                const shipper = this.state.shippers[idx];
                                const control = (React.createElement(Glyphicon, { glyph: "remove", style: { color: 'red', cursor: 'pointer' } }));
                                return (React.createElement("div", null,
                                    React.createElement(TariffConfirmationButton, { controlTitle: control, controlType: "icon", skipConfirmation: false, alertTitle: t('WARNING'), message: t('IMPACT_CUSTOMERS_MSG'), confirmTitle: t('CONFIRM_UNASSIGN'), dismissTitle: titleize(t('CANCEL')), onConfirm: (password) => this.remove(shipper, password), disabled: false, store: CustomersStore })));
                            },
                        ],
                    },
                },
            ],
            pagination: {
                page: 0,
                perPage: 10,
            },
        };
    }
    componentDidMount() {
        CustomersStore.addChangeListener(this.onChange);
        CustomersStore.reset();
        CustomersStore.clearShippers();
        const tariff = this.props.tariff;
        if (tariff._id) {
            CustomersAPIUtils.getShippersWithTariff(tariff._id);
        }
    }
    componentWillUnmount() {
        CustomersStore.removeChangeListener(this.onChange);
    }
    handleStoreChange() {
        if (CustomersStore.getAssignedShipperId()) {
            getTariffsUsage();
            CustomersStore.reset();
            const tariff = this.props.tariff;
            if (tariff._id) {
                CustomersAPIUtils.getShippersWithTariff(tariff._id);
            }
        }
        else {
            this.setState(getStateFromStore());
        }
    }
    onSelect(eventKey) {
        this.setState((prevState) => {
            return {
                pagination: Object.assign(Object.assign({}, (prevState.pagination || {})), { page: eventKey - 1 }),
            };
        });
    }
    handleShipperSelection() {
        return (_, selection) => {
            if (selection && selection.value) {
                CustomersAPIUtils.getShipper(selection.value);
            }
            else {
                this.setState({ shipper: null });
            }
        };
    }
    assignShipper() {
        const { t } = this.props;
        return (password) => {
            const shipper = this.state.shipper;
            const tariff = this.props.tariff;
            let duplicateTariff = false;
            let assignedTariff = {};
            if (shipper && tariff) {
                _.forEach(shipper.tariffs, function (_tariff) {
                    if (_.intersection(_tariff.markets, tariff.markets).length) {
                        duplicateTariff = true;
                        assignedTariff = tariff;
                    }
                });
                if (duplicateTariff) {
                    this.showTariffWarning('Error', t('DUPLICATE_TARIFF_ERROR_MSG', {
                        tariffName: assignedTariff.name,
                    }));
                }
                else if (_.find(shipper.tariffs, { _id: tariff._id })) {
                    this.showTariffWarning('Error', t('SHIPPER_ALREADY_HAS_TARIFF'));
                }
                else {
                    CustomersAPIUtils.assignTariff(shipper, tariff, password);
                }
            }
        };
    }
    remove(shipper, password) {
        const tariff = this.props.tariff;
        if (shipper && shipper.tariffs) {
            shipper.tariffs = shipper.tariffs.filter((item) => item !== tariff._id);
            CustomersAPIUtils.unassignTariff(shipper, tariff, password);
        }
    }
    render() {
        const { t } = this.props;
        const columns = this.state.columns;
        let shippers = this.state.shippers || [];
        const shipper = this.state.shipper;
        const sortingColumns = this.state.sortingColumns;
        const pagination = this.state.pagination;
        shippers = sort.sorter({ columns: columns, sortingColumns, sort: orderBy })(shippers);
        const paginated = paginate(shippers, pagination);
        const assignButton = (React.createElement(TariffConfirmationButton, { controlTitle: t('ASSIGN'), controlType: "button", skipConfirmation: false, alertTitle: t('WARNING'), message: t('IMPACT_CUSTOMERS_MSG'), confirmTitle: t('CONFIRM_ASSIGN'), dismissTitle: titleize(t('CANCEL')), onConfirm: this.assignShipper(), disabled: !shipper, store: CustomersStore }));
        const paginatorControl = (React.createElement(Col, { xs: 6 },
            React.createElement(Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true, items: paginated.amount, maxButtons: 5, activePage: pagination.page + 1, onSelect: (eventKey) => this.onSelect(eventKey) })));
        const perPageControl = (React.createElement("div", { className: "mb-4" },
            React.createElement("label", { htmlFor: "perPageControl", className: "mb-2 form-label" }, t('PER_PAGE')),
            React.createElement("input", { type: "number", className: "w-20 ml-2 form-field", id: "perPageControl", defaultValue: pagination.perPage, onChange: this.onPerPage }),
            "\u00A0"));
        return (React.createElement("div", null,
            React.createElement("form", { className: "" },
                perPageControl,
                React.createElement("div", { className: "flex items-end mb-4 -mx-2" },
                    React.createElement("div", { className: "px-2" },
                        React.createElement("label", { htmlFor: "CustomerSearch" },
                            t('ASSIGN_TO_SHIPPER'),
                            ":"),
                        React.createElement(CustomerSearch, { type: "shippers", className: "form-field", onSelect: this.handleShipperSelection(), placeholder: t('SEARCH_FOR_SHIPPER_PLACEHOLDER') })),
                    React.createElement("div", { className: "px-2" }, assignButton))),
            React.createElement("div", null,
                React.createElement(Table.Provider, { className: "default-table", columns: columns },
                    React.createElement(Table.Header, null),
                    React.createElement(Table.Body, { rows: paginated.data, rowKey: "_id" }))),
            React.createElement(Grid, { fluid: true },
                React.createElement(Row, { className: "show-grid" }, paginatorControl))));
    }
}
TariffShippersTable.propTypes = {
    tariff: PropTypes.object.isRequired,
};
export default withTranslation()(TariffShippersTable);
